"use strict";
import React from "react";
import _ from "underscore";
import LinkedStateMixin from "react-addons-linked-state-mixin";
import format from "../../formatters/general";
import classNames from "classnames";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
export const validId = (id) => {
  return !!id && id !== "";
};
function keyPressNotifier(event, lineItem, action) {
  if (event.charCode === 13) {
    action();
  }
}
function typeWarning(state) {
  if (!validId(state.tms_line_item_type_id)) {
    return /* @__PURE__ */ React.createElement("small", { className: "error" }, "Please select type");
  }
}
function possibleActions(props, lineItem) {
  if (!props.readOnly) {
    return /* @__PURE__ */ React.createElement("div", { className: "small-1 column line-items__actions" }, /* @__PURE__ */ React.createElement(
      "a",
      {
        onClick: props.removeItem(lineItem),
        className: "line-items__trash",
        title: "Delete item"
      },
      /* @__PURE__ */ React.createElement("i", { className: "fi-trash" })
    ));
  } else {
    return /* @__PURE__ */ React.createElement("div", { className: "small-1 column line-items__actions" });
  }
}
function lineItemTypeOptions(props) {
  const empty = { id: "", description: "Select Type" };
  const types = [empty].concat(_.sortBy(props.lineItemTypes, "description"));
  return types.map((item) => /* @__PURE__ */ React.createElement("option", { value: item.id, key: "item_option_" + item.id }, item.description));
}
const LineItem = React.createClass({
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    return {};
  },
  componentWillMount: function() {
    this.setupFields(this.props);
  },
  componentWillReceiveProps: function(newProps) {
    if (newProps !== this.props) {
      this.setupFields(newProps);
    }
  },
  setupFields: function(props) {
    const newState = {
      tms_line_item_type_id: props.lineItem.tms_line_item_type_id,
      description: props.lineItem.description,
      total: format.cleanAmount(props.lineItem.total)
    };
    if (newState.tms_line_item_type_id === this.state.tms_line_item_type_id && newState.description === this.state.description && this.state.editing) {
      newState.total = this.state.total;
    }
    this.setState(newState);
  },
  changeDescription: function(lineItem) {
    return () => {
      this.changeField(this.state.description, "description", lineItem);
    };
  },
  changeField: function(value, field, lineItem) {
    this.setState({ updating: true, editing: false });
    this.props.updateItem(lineItem, field, value).then(() => {
      if (this.isMounted()) this.setState({ updating: false });
    });
  },
  changeTypeId: function(lineItem) {
    return (e) => {
      const newId = e.target.value;
      if (this.state.total) {
        lineItem.total = format.cleanAmount(this.state.total);
      }
      if (this.state.description) {
        lineItem.description = this.state.description;
      }
      this.changeField(newId, "tms_line_item_type_id", lineItem);
    };
  },
  changeTotal: function(lineItem) {
    return (e) => {
      let total = format.cleanAmount(this.state.total);
      if (total === null) {
        total = format.cleanAmount(0);
      }
      this.changeField(total, "total", lineItem);
    };
  },
  render: function() {
    const lineItem = this.props.lineItem;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "data-component": "LineItem",
        className: "small-10 column line-items__line-item"
      },
      /* @__PURE__ */ React.createElement("div", { className: "row" }, this.typeSelector(lineItem), this.possibleDescriptionField(lineItem), this.amountField(lineItem), possibleActions(this.props, lineItem))
    );
  },
  possibleDescriptionField: function(lineItem) {
    if (this.props.creatingLoad) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-3 column" }, /* @__PURE__ */ React.createElement(
        ValueLinkTextDroppableInput,
        {
          type: "text",
          disabled: this.state.updating || this.props.readOnly,
          valueLink: this.linkState("description"),
          onBlur: this.changeDescription(lineItem),
          onKeyPress: _.partial(
            keyPressNotifier,
            _,
            lineItem,
            this.changeDescription()
          ),
          inputDropped: this.changeDescription(lineItem),
          placeholder: "description",
          className: "line-item__description"
        }
      ));
    }
  },
  amountField: function(lineItem) {
    const colClass = this.props.creatingLoad ? "small-2" : "small-4";
    return /* @__PURE__ */ React.createElement("div", { className: "column " + colClass }, /* @__PURE__ */ React.createElement("div", { className: "row collapse" }, /* @__PURE__ */ React.createElement("div", { className: "small-2 columns" }, /* @__PURE__ */ React.createElement("span", { className: "prefix" }, "$")), /* @__PURE__ */ React.createElement("div", { className: "small-8 columns" }, /* @__PURE__ */ React.createElement(
      ValueLinkTextDroppableInput,
      {
        type: "text",
        disabled: this.state.updating || this.props.readOnly,
        valueLink: this.linkState("total"),
        onFocus: this.setEditing,
        onBlur: this.changeTotal(lineItem),
        onKeyPress: _.partial(
          keyPressNotifier,
          _,
          lineItem,
          this.changeTotal()
        ),
        inputDropped: this.changeTotal(lineItem),
        placeholder: "amount"
      }
    ))));
  },
  setEditing: function() {
    this.setState({ editing: true });
  },
  typeSelector: function(lineItem) {
    const selectClasses = classNames({
      "small-4": this.props.creatingLoad,
      "small-5": !this.props.creatingLoad,
      column: true,
      error: !validId(this.state.tms_line_item_type_id)
    });
    return /* @__PURE__ */ React.createElement("div", { className: selectClasses }, /* @__PURE__ */ React.createElement(
      "select",
      {
        type: "text",
        placeholder: "Description",
        value: this.state.tms_line_item_type_id,
        onChange: this.changeTypeId(lineItem),
        disabled: this.state.updating || this.props.readOnly
      },
      lineItemTypeOptions(this.props)
    ), typeWarning(this.state));
  }
});
export default LineItem;
